import { EMPTY_STRING } from '../../constants/common'
import { deleteApi, getApi, postApi, putApi } from '../../utils/api'

import { FILTER_SINGLE_FIELD_API_ALIASES } from './Filter.constants'

export function getFilterSingleFieldData({ apiUrl, entity, options, params }) {
  const endpoint = apiUrl || FILTER_SINGLE_FIELD_API_ALIASES[entity.single]

  if (!endpoint) {
    console.error(
      'URL for filter data retrieval was not found. Please check `FILTER_SINGLE_FIELD_API_ALIASES` constant'
    )
  }

  return getApi({ endpoint, options, params })
}

export function getFilterTemplates(params, id) {
  return getApi({
    endpoint: `idwell-api/api/v3/table/filter-templates/${id ? `${id}/` : EMPTY_STRING}`,
    params,
  })
}

export function createFilterTemplate(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/table/filter-templates/',
  })
}

export function deleteFilterTemplate(id) {
  return deleteApi({
    endpoint: `idwell-api/api/v3/table/filter-templates/${id}/`,
  })
}

export function updateFilterTemplate(data, id) {
  return putApi({
    data,
    endpoint: `idwell-api/api/v3/table/filter-templates/${id}/`,
  })
}
